module.exports = __webpack_public_path__ + "img/metalRecycling.61afb8df.png";